import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { Label } from 'containers';

import styles from './LabelComp.scss';

const LabelComp = ({
  labels
}) => (
  <div className={styles.LabelComp}>
    {
      labels.map(item => (
        <Label
          key={uuidv4()}
          name={item.label}
          invert={item.invert}
          number={item.num}
        />
      ))
    }
  </div>
);

LabelComp.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default LabelComp;



// WEBPACK FOOTER //
// ./src/containers/LabelComp/LabelComp.js